module.exports = __webpack_public_path__ + "static/media/23.39b0e819.png";